import GameIds from 'a/hub/data/GameIds';

export const GAME_ID = GameIds.A11Y;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  HOME: 'HOME',
  LOADING: 'LOADING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
};
